var rich_content_viewer_default = {
  "fontElementMap": "GaC3v",
  "wrapper": "Hquzw",
  "pluginContainerMobile": "MLrK-",
  "viewer": "_9bS1K",
  "android": "xHzoO",
  "rootedTraversedContent": "_2QXJZ",
  "atomic": "e8eWz",
  "toolbar": "pRs9Q",
  "block": "kg5Ve"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
